// test2258
(2258 && 0);
